import axios, { AxiosResponse } from "axios";
import { Message } from "../Models/Message";
import { SERVERURL } from "../Globals/Constants";

export const createMessage = async (email: Message): Promise<number> => {
  try {
    const response: AxiosResponse = await axios.post<Message>(
      `${SERVERURL}/api/mail/create`,
      email,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    return response.status;
  } catch (error: any) {
    if (error.response) {
      return error.response.status;
    } else {
      return Promise.reject(error.message);
    }
  }
};
